var _path, _path2, _path3, _circle, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckInEyeGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9 148.631C110.43 148.631 136.8 121.462 136.8 87.9465C136.8 54.4312 110.43 27.2617 77.9 27.2617C45.3704 27.2617 19 54.4312 19 87.9465C19 121.462 45.3704 148.631 77.9 148.631Z",
    fill: "#EDA4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.399 140.802C135.781 140.802 159.599 116.262 159.599 85.9898C159.599 55.7179 135.781 31.1777 106.399 31.1777C77.0177 31.1777 53.1992 55.7179 53.1992 85.9898C53.1992 116.262 77.0177 140.802 106.399 140.802Z",
    fill: "url(#paint0_linear_9831_103018)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 20.4316C104.145 20.4316 120.38 25.4679 134.254 35.4854C148.137 45.5091 159.713 60.5619 168.956 80.6816V80.6826C170.349 83.7672 170.346 87.2746 168.959 90.29V90.291C159.715 110.424 148.142 125.484 134.261 135.512C120.389 145.532 104.155 150.568 85.5 150.568C66.8553 150.568 50.6201 145.532 36.7461 135.515C22.8621 125.49 11.2849 110.435 2.04102 90.3125H2.04199C1.35636 88.812 1 87.1717 1 85.5098C1.00003 83.8478 1.35531 82.2065 2.04102 80.7061C11.2848 60.5737 22.8571 45.5142 36.7383 35.4873C50.6098 25.4674 66.8453 20.4316 85.5 20.4316Z",
    fill: "url(#paint1_linear_9831_103018)",
    stroke: "url(#paint2_linear_9831_103018)",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.4996,
    cy: 85.4996,
    r: 45.6364,
    fill: "white",
    fillOpacity: 0.2,
    stroke: "url(#paint3_linear_9831_103018)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1816 81.6142L80.1187 101.046L108.818 69.9551",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9831_103018",
    x1: 69.1592,
    y1: 53.1026,
    x2: 158.603,
    y2: 89.5642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CD9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9831_103018",
    x1: 143.795,
    y1: 58.2953,
    x2: 57.0811,
    y2: 143.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBFBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303579,
    stopColor: "#5DEBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553499,
    stopColor: "#88D7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52CAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9831_103018",
    x1: 35.91,
    y1: 19.4316,
    x2: 25.8142,
    y2: 146.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9831_103018",
    x1: 58.4506,
    y1: 38.8633,
    x2: 49.2672,
    y2: 127.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInEyeGradient);
export default __webpack_public_path__ + "static/media/check-in-eye-gradient.ec72e4995c2e963d3265ad5496506723.svg";
export { ForwardRef as ReactComponent };